<template lang="pug">
  div(v-bind:class="{ booksWrap: books.length != 0 }")
      div(v-for="(book, index) in books")
        div(v-if="index < 10" class="item" v-bind:class="{ isEven: index%2 == 1 }")
          p(v-on:click="selectBook(book.isbn)")
            | {{book.name}}
</template>

<script>

import _ from 'lodash'
import axios from 'axios'
import qs from 'qs'

export default{
  name: 'incremental-search-suggestions',
  data(){
    return {
      books: []
    }
  },
  props: {
    attribute: {
      type: String,
    },
    searchApiPath: {
      type: String,
      required: true
    },
    searchQueryName: {
      type: String,
      required: true
    }
  },
  watch: {
    "attribute": function (newSearchWord, oldSearchWord) {
      this.searchBookWithInterval()
    }
  },
  created: function () {
    this.searchBookWithInterval = _.throttle(this.searchBook, 500)
  },
  methods: {
    searchBook: function (e) {
      if (this.attribute == '') {
        this.books = [];
      } else {
        var baseURI = window.location.origin + this.searchApiPath
        var query = this.searchQueryName + "=" + encodeURIComponent("%" + this.attribute + "%")
        axios.get(baseURI + query)
            .then(response => {
              var resultSet = response.data.books
              if (resultSet.length == 0) {
                this.books = []
              } else {
                this.books = resultSet;
              }
            })
            .catch(function (error) {
              this.books = [];
              console.log('ERROR!! happend by Backend.')
            });
      }
    },
    selectBook: function (isbn) {
      this.$emit('update:attribute', isbn)
      this.books = []
    }
  }
}

</script>